// dependencies
import React from "react";

import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// styles
import css from "../ColumnPicker.module.scss";
// schema
import { InfoEntry } from "../index";

interface BaseProps {
	handleClose: () => void;
	info: InfoEntry[];
}

const InfoPanel = (props: BaseProps) => {
	const { handleClose, info } = props;

	return (
		<div className={css.infoPanel}>
			<div className={css.closeInfoPanel} onClick={handleClose} data-testid="close-panel">
				<FontAwesomeIcon icon={faTimes} />
			</div>
			<div className={css.infoValues}>
				{info.map((infoItem) => {
					const displayValue = !Array.isArray(infoItem.value)
						? infoItem.value
						: // for grouped questions, value is a list of questions we display as a bulleted list
							infoItem.value.map((value, index) => {
								return (
									<ul key={`${value}-${index}`}>
										<li>{value}</li>
									</ul>
								);
							});
					return (
						<div key={infoItem.label} className={css.infoItem}>
							<div className={css.infoKey}>{`${infoItem.label}:`}</div>
							<div className={css.infoValue}>{displayValue}</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default InfoPanel;
